import { useEffect } from "react";
import {
  useAlert,
  setGlobalAlertFunctions,
} from "@/contexts/AlertModalContext";

/**
 * Componente bridge para inicializar as funções globais de alerta
 * Permite usar o `alert` importado diretamente em qualquer lugar
 */
export const AlertBridge = () => {
  const alertFunctions = useAlert();

  useEffect(() => {
    setGlobalAlertFunctions(alertFunctions);
  }, [alertFunctions]);

  return null;
};
